export const APP_TITLE = 'MYGAME'
